var _path, _circle, _path2, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchCoaches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2632 12L15.1316 16.8571M11.8947 12L10.119 21.1042C10.0461 21.4778 10.1917 21.8603 10.4945 22.091L12.394 23.5383C12.752 23.811 13.248 23.811 13.606 23.5383L14.5 22.8571",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 6,
    r: 5,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 26.7621C14.2756 27.1783 9.35175 27.0484 5.15305 26.3726L3.84109 26.1615C3.35638 26.0834 3 25.6651 3 25.1742V21.8872C3 16.4267 7.47715 12 13 12C15.8146 12 18.3576 13.1497 20.1748 15",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21,
    r: 6,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4697 30.5303C28.7626 30.8232 29.2374 30.8232 29.5303 30.5303C29.8232 30.2374 29.8232 29.7626 29.5303 29.4697L29 30L28.4697 30.5303ZM24 25L23.4697 25.5303L28.4697 30.5303L29 30L29.5303 29.4697L24.5303 24.4697L24 25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCoaches);
export default __webpack_public_path__ + "static/media/search-coaches.86ee5b1b44233461db586aa94615af1e.svg";
export { ForwardRef as ReactComponent };